(() => {
  if (customElements.get('adc-rocket-rental')) return;
  class RocketRental extends HTMLElement {
    static calculate(base, term, deposit = 0) {
      const factor = {12:110000,24:110000,36:110000,48:115500,60:121275}[term];
      if (!factor || !Number.isFinite(base) || base < 0) throw new Error('Invalid rental inputs');
      const total = Math.round(base * factor / 100000);
      const upfront = Math.min(total, Math.max(0, Math.round(Number(deposit) || 0)));
      const remaining = total - upfront;
      let monthly = Math.round(remaining / term);
      if (monthly * (term - 1) > remaining) monthly = Math.floor(remaining / term);
      return {total, upfront, remaining, monthly, final: remaining - monthly * (term - 1), term};
    }
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected) return;
      if (this.ready) return;
      const payload = this.querySelector('[data-rental-data]');
      if (!payload?.textContent.trim()) {
        if (!this.observer) {
          this.observer = new MutationObserver(() => this.initialize());
          this.observer.observe(this, {childList:true, subtree:true, characterData:true});
        }
        return;
      }
      this.observer?.disconnect();
      this.observer = null;
      this.ready = true;
      this.data = JSON.parse(payload.textContent);
      this.$ = selector => this.querySelector(selector);
      this.termInput = this.$('[data-term-input]');
      this.observer = new MutationObserver(() => {
        if (!this.isConnected) return;
        if (this.termInput !== this.querySelector('[data-term-input]')) {
          this.disconnectedCallback();
          this.initialize();
        } else if (!this.querySelector('[data-monthly]')?.textContent.trim()) {
          this.data = JSON.parse(this.querySelector('[data-rental-data]').textContent);
          this.render();
        }
      });
      this.observer.observe(this, {childList:true, subtree:true, characterData:true});
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.dataset.currency }).format(value / 100);
      this.$('[data-term-input]').addEventListener('input', () => this.render());
      this.$('[data-deposit]').addEventListener('input', () => this.render());
      this.$('[data-deposit]').addEventListener('change', () => {
        const field = this.$('[data-deposit]'), requested = Math.round((Number(field.value) || 0) * 100);
        const estimate = this.estimate();
        if (requested !== estimate.upfront) {
          field.value = (estimate.upfront / 100).toFixed(2);
          this.$('[data-status]').textContent = this.data.limitMessage;
        } else this.$('[data-status]').textContent = '';
        this.render();
      });
      if (this.dataset.mode === 'product') {
        this.scope = this.closest('.shopify-section') || document;
        this.handleChange = () => this.render();
        this.scope.addEventListener('change', this.handleChange);
        this.scope.addEventListener('variant:update', this.handleChange);
      }
      this.render();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      if (this.scope && this.handleChange) {
        this.scope.removeEventListener('change', this.handleChange);
        this.scope.removeEventListener('variant:update', this.handleChange);
      }
      this.ready = false;
    }
    base() {
      if (this.dataset.mode !== 'product') return Math.round(Number(this.dataset.base));
      const id = this.scope?.querySelector('form input[name="id"]')?.value;
      const variant = this.data.variants.find(variant => String(variant.id) === String(id)) || this.data.variants[0];
      const quantity = Math.max(1, Math.floor(Number(this.scope?.querySelector('input[name="quantity"]')?.value) || 1));
      this.quantity = quantity;
      return (variant?.rrp || Number(this.dataset.base)) * quantity;
    }
    estimate() {
      return RocketRental.calculate(this.base(), Number(this.$('[data-term-input]').value), Math.round((Number(this.$('[data-deposit]').value) || 0) * 100));
    }
    render() {
      const value = this.estimate(), data = this.data;
      this.$('[data-rrp]').textContent = this.money(this.base());
      this.$('[data-term]').textContent = value.term;
      this.$('[data-term-input]').setAttribute('aria-valuetext', `${value.term} ${data.monthsLabel}`);
      this.$('[data-deposit]').max = (value.total / 100).toFixed(2);
      for (const key of ['monthly','total','remaining','final']) this.$(`[data-${key}]`).textContent = this.money(value[key]);
      this.$('[data-upfront]').textContent = this.money(value.upfront);
      const items = this.dataset.mode === 'cart' ? data.items.map(item => `${item.quantity} × ${item.title}`) : [`${this.quantity || 1} × ${data.title}`];
      const message = [data.quoteSubject, ...items, `${data.termLabel}: ${value.term} ${data.monthsLabel}`, `${data.depositLabel}: ${this.money(value.upfront)}`, `${this.money(value.monthly)} ${data.monthlyLabel}`, `${data.finalLabel}: ${this.money(value.final)}`, `${data.totalLabel}: ${this.money(value.total)}`].join('\n');
      const url = new URL(this.dataset.contact || '/pages/contact', location.origin);
      url.searchParams.set('equipment_quote', message);
      this.$('[data-quote]').href = url.href;
    }
  }
  customElements.define('adc-rocket-rental', RocketRental);
  const prefill = () => {
    const message = new URLSearchParams(location.search).get('equipment_quote');
    const field = document.querySelector('textarea[name="contact[body]"], textarea[name="contact[message]"]');
    if (message && field && !field.value.trim()) field.value = message.slice(0,12000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill, {once:true}); else prefill();
})();
